import {
    PermitAssignmentsState,
    PermitAssignmentsActionTypes,
    LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL,
    LOAD_PERMIT_REGISTER_USERS_STARTED,
    LOAD_PERMIT_REGISTER_USERS_FAILED,
} from "./types";

const initialState: PermitAssignmentsState = {
    loading: false,
    permitRegisterUsers: [],
};

const reducer = (state = initialState, action: PermitAssignmentsActionTypes) => {
    switch (action.type) {
        case LOAD_PERMIT_REGISTER_USERS_STARTED:
            return {
                ...state,
                loading: true,
            };
        case LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL:
            return {
                ...state,
                loading: false,
                permitRegisterUsers: action.permitRegisterUsers,
            };
        case LOAD_PERMIT_REGISTER_USERS_FAILED:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default reducer;
